import React from 'react';
import defaultStyle from './index.module.scss';
import SoyRappi from '../../../assets/soy-rappi.svg';
import FirsPhoto375 from '../../../assets/fisrtPhoto375.png';
import passwordIcon from '../../../assets/icon (2).svg';
import documentIcon from '../../../assets/icon (1).svg';
import Courier375 from '../../../assets/courier375.png';
import Contabilizate from '../../../assets/contabilizate.svg';
import PcIcon from '../../../assets/pcIcon.svg';
import documentUpload from '../../../assets/document.svg';
import { getFooterText } from '../../../util/stringUtils';
import { CSD_URL, ELECTRONIC_SIGNATURE_URL } from '../../../constants/links';

const LandingPageMobile: React.FC = () => {
  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.headerContainer}>
        <img
          src={SoyRappi}
          alt={'SoyRappi'}
          className={defaultStyle.soyRappi}
        />
      </div>
      <div className={defaultStyle.firstPhotoContainer}>
        <img
          src={FirsPhoto375}
          alt={'FirstPhoto375'}
          className={defaultStyle.firstPhoto375}
        />
        <div className={defaultStyle.tittleOne}>Así registras</div>
        <div className={defaultStyle.tittleTwo}>tu facturación</div>
        <p className={defaultStyle.description}>
          Como repartidor en <br />
          SoyRappi es indispensable <br />
          que anualmente emitas tus facturas. <br />
          Conoce cómo <br />
          hacerlo, los documentos <br />
          necesarios y más.
        </p>
      </div>
      <div className={defaultStyle.detailsContainer}>
        <div className={defaultStyle.detailsTitle}>
          ¿Qué documentos necesito?
        </div>
        <div className={defaultStyle.detailsDescription}>
          Para poder registrar tu facturación debes contar con los siguientes
          documentos fiscales,{' '}
          <b>
            si cuentas solamente con tu FIEL, te <br />
            ayudaremos a conseguir tus sellos:
          </b>
        </div>
      </div>
      <div className={defaultStyle.documentationContainer}>
        <div className={defaultStyle.documentationTittle}>Sellos:</div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={passwordIcon}
            alt={'passwordIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Contraseña del certificado CSD
          </div>
        </div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={documentIcon}
            alt={'documentIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Clave del certificado CSD (.key)
          </div>
        </div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={documentIcon}
            alt={'documentIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Certificado CSD (.cer)
          </div>
        </div>
        <div className={defaultStyle.documentationTittleFiel}>FIEL:</div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={passwordIcon}
            alt={'passwordIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Contraseña del certificado de <br />
            firma electrónica avanzada
          </div>
        </div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={documentIcon}
            alt={'documentIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Clave del certificado fiel (.key)
          </div>
        </div>
        <div className={defaultStyle.documentListContainer}>
          <img
            src={documentIcon}
            alt={'documentIcon'}
            className={defaultStyle.passwordIcon}
          />
          <div className={defaultStyle.documentDescription}>
            Certificado de firma electrónica <br />
            avanzada (.cer)
          </div>
        </div>
      </div>
      <div className={defaultStyle.instructionsContainer}>
        <img
          src={Courier375}
          alt={'Courier375'}
          className={defaultStyle.courierImage}
        />
        <div className={defaultStyle.instructionsTittle}>
          Te ayudamos a gestionar tus documentos <br />
          fiscales
        </div>
        <div className={defaultStyle.instructionsDescription}>
          Para poder emitir facturas debes <br />
          contar con tus credenciales <br />
          fiscales obtenidas en el SAT:
          <b>
            {' '}
            e.firma <br />
            (fiel) y CSD{' '}
          </b>{' '}
          (la e.firma y CSD están <br />
          conformados por 4 archivos y 2 <br />
          contraseñas independientes)
          <br />
          <br />
          <b>
            Es necesario tener descargados <br />
            estos documentos cuando <br />
            realices tu registro.
          </b>
          <br />
          <br />
          SoyRappi ha puesto a disposición <br />
          de los repartidores, asesoría <br />
          gratuita por parte de <br />
          <b>Contabilízate,</b> para poder gestionar <br />
          los documentos fiscales requeridos.
          <button
            className={defaultStyle.contabilizateButton}
            onClick={() =>
              window.open(
                'https://grupo.detecno.com/contabilizate-rappi-1/',
                '_blank'
              )
            }
          >
            <img
              src={Contabilizate}
              alt={'Contabilizate'}
              style={{ marginRight: '12px' }}
            />
            Obtener asesoría
          </button>
        </div>
      </div>
      <div className={defaultStyle.breakerContainer}>
        <div className={defaultStyle.breakerDescription}>
          Ten en cuenta que si obtuviste tus credenciales fiscales recientemente
          deberás esperar 72 horas a que éstas se validen ante el SAT para que
          puedas realizar tu registro sin problemas.
        </div>
      </div>
      <div className={defaultStyle.documentsContainer}>
        <div className={defaultStyle.documentsTitle}>
          ¿Cómo registro mis documentos con SoyRappi?
        </div>
        <div className={defaultStyle.documentsTitleDescription}>
          Si cuentas sólo con tu FIEL súbela al portal y te ayudaremos a generar
          los Sellos con ayuda de nuestros aliados
        </div>
        <div className={defaultStyle.cardsContainer}>
          <div className={defaultStyle.cardContainer}>
            <img
              src={PcIcon}
              alt={'PcIcon'}
              style={{ marginBottom: '16px' }}
              className={defaultStyle.pcIcon}
            />
            <div className={defaultStyle.cardTittle}>
              Ingresa desde una PC <br /> con tu correo o <br /> número de
              telefono
            </div>
            <br />
            <div className={defaultStyle.cardDescription}>
              Con el boton a continuación <br /> podrás empezar el proceso.
            </div>
          </div>
          <br />
          <br />
          <div className={defaultStyle.cardContainer}>
            <img
              src={documentUpload}
              alt={'documentUpload'}
              style={{ marginBottom: '16px' }}
              className={defaultStyle.documentUpload}
            />
            <div className={defaultStyle.cardTittle}>
              Ve a la sección de documentos fiscales
            </div>
            <br />
            <div className={defaultStyle.cardDescription}>
              Ingresa tu e.firma y CSD y completa la subida de los documentos.
            </div>
          </div>
        </div>
      </div>
      <div className={defaultStyle.border}></div>
      <div className={defaultStyle.helpInformationContainer}>
        <div className={defaultStyle.informationTittle}>
          Información de ayuda
        </div>
        <div className={defaultStyle.informationSubtitle}>
          Como conseguir una asesoría <br />
          gratuita con Contabilízate
        </div>
        <div className={defaultStyle.informationDetail}>
          Para recibir atención gratuita de
          <br />
          nuestro aliado Contabilízate, puedes <br />
          contactarte acá con su línea de <br />
          WhatsApp o <br />
          visita{' '}
          <a
            href={'https://grupo.detecno.com/contabilizate-rappi-1/'}
            className={defaultStyle.urlStyle}
          >
            www.contabilizate.com
          </a>
        </div>
        <div className={defaultStyle.borderInformation}></div>
        <div className={defaultStyle.informationSubtitle}>Links de ayuda</div>
        <div className={defaultStyle.informationDetail}>
          Tramita tu CSD directamente en{' '}
          <a href={CSD_URL} className={defaultStyle.urlStyle}>
            {CSD_URL}
          </a>{' '}
          <br /> <br />
          Tramita tu firma electrónica en{' '}
          <a href={ELECTRONIC_SIGNATURE_URL} className={defaultStyle.urlStyle}>
            {ELECTRONIC_SIGNATURE_URL}
          </a>
        </div>
        <div className={defaultStyle.borderInformation}></div>
        <div className={defaultStyle.informationSubtitle}>
          Atención específica a procesos del SAT
        </div>
        <div className={defaultStyle.informationDetail}>
          Para orientación fiscal vía telefónica <br />
          por parte del SAT da click{' '}
          <a
            href={
              'https://www.sat.gob.mx/consulta/50308/solicita-orientacion-fiscal-via-telefonica'
            }
            className={defaultStyle.urlStyle}
          >
            aquí
          </a>{' '}
          o llama <br />
          al 01 (55) 627 22 728
        </div>
        <div className={defaultStyle.borderInformation}></div>
        <div className={defaultStyle.informationSubtitle}>
          Actualización de documentos
        </div>
        <div className={defaultStyle.informationDetail}>
          Si tus sellos o FIEL se encuentran vencidos, los podrás actualizar en
          el siguiente link{' '}
          <a
            href={'https://satid.sat.gob.mx/'}
            className={defaultStyle.urlStyle}
          >
            https://satid.sat.gob.mx/
          </a>
        </div>
        <div className={defaultStyle.informationSubtitle}>
          ¿Dudas sobre tus declaraciones?
        </div>
        <div className={defaultStyle.informationDetail}>
          Para orientación detallada de declaraciones, dirígete a la siguiente
          web{' '}
          <a
            href={'https://www.heru.app/preguntas-frecuentes'}
            className={defaultStyle.urlStyle}
          >
            https://www.heru.app/preguntas-frecuentes
          </a>
        </div>
        <div className={defaultStyle.importantMessage}>
          <div className={defaultStyle.importantSubtitle}>
            Entendiendo que esta documentación es sensible y delicada,
            garantizamos que la misma será tratada de manera responsable, de
            conformidad con lo establecido en el Aviso de Privacidad de
            SoyRappi.
          </div>
        </div>
      </div>
      <div className={defaultStyle.border}></div>
      <div className={defaultStyle.footerContainer}>
        <div className={defaultStyle.redirect}>
          <a
            href='https://soyrappi.com.mx/'
            target='_blank'
            className={defaultStyle.urlStyle}
          >
            Ir a Soy Rappi MX
          </a>
        </div>
        <div className={defaultStyle.redirect} style={{ color: '#868D97' }}>
          {getFooterText()}
        </div>
      </div>
    </div>
  );
};

export default LandingPageMobile;
